// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const whimsicott: PokeData = {
  "id": 547,
  "name": "whimsicott",
  "height": 7,
  "weight": 66,
  "base_experience": 168,
  "types": [
    PokeType.GRASS,
    PokeType.FAIRY
  ],
  "api_moves": [
    "gust",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "cotton-spore",
    "giga-drain",
    "charm",
    "sunny-day",
    "memento",
    "helping-hand",
    "endeavor",
    "tailwind",
    "energy-ball",
    "cotton-guard",
    "hurricane",
    "fairy-wind",
    "moonblast"
  ],
  "moves": [
    "gust",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sunny-day",
    "tailwind",
    "energy-ball",
    "hurricane",
    "moonblast",
    "moonlight",
    "mist-terrain",
    "flower-rush"
  ],
  "evolution_chain": {
    "id": 278,
    "item": null,
    "species": [
      {
        "name": "cottonee",
        "order": 547,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whimsicott",
        "order": 548,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 546,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 176,
    "ability_power": 117
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
